import {
  QUESTION_TYPE_DESCRIPTION,
  QUESTION_TYPE_TITLE
} from './questionTypes'

export const FORM_PROPERTY_TYPE_BACKGROUND = 'background'
export const FORM_PROPERTY_TYPE_CLOSED_MESSAGE = 'closedMessage'
export const FORM_PROPERTY_TYPE_BUTTON = 'submitButton'
export const FORM_PROPERTY_TYPE_BUTTON_TEXT = 'submitButtonText'
export const FORM_PROPERTY_TYPE_DEFAULT_FONT_STYLES = 'defaultStyles'
export const FORM_PROPERTY_TYPE_DESCRIPTION = 'description'
export const FORM_PROPERTY_TYPE_ENDPAGE = 'endpage'
export const FORM_PROPERTY_TYPE_ENDPAGE_TEXT = 'text'
export const FORM_PROPERTY_TYPE_ENDPAGE_REDIRECT = 'redirect'
export const FORM_PROPERTY_TYPE_FOOTER = 'footer'
export const FORM_PROPERTY_TYPE_HEADER_LOGO = 'logo'
export const FORM_PROPERTY_TYPE_IMAGE_POSITION = 'position'
export const FORM_PROPERTY_TYPE_IMAGE_SIZE = 'size'
export const FORM_PROPERTY_TYPE_IMAGE_URL = 'imageUrl'
export const FORM_PROPERTY_TYPE_HIDDEN_FIELDS = 'hiddenFields'
export const FORM_PROPERTY_TYPE_NAME = 'name'
export const FORM_PROPERTY_TYPE_REDIRECT_URL = 'redirectUrl'
export const FORM_PROPERTY_TYPE_TITLE = 'title'
export const FORM_PROPERTY_TYPE_WALLPAPER = 'wallpaper'

export const FORM_PROPERTY_MAP_BY_QUESTION_TYPE = {
  [QUESTION_TYPE_TITLE]: FORM_PROPERTY_TYPE_TITLE,
  [QUESTION_TYPE_DESCRIPTION]: FORM_PROPERTY_TYPE_DESCRIPTION
}
